export class Alert {
  constructor(id, name, organization, type, frequency, lastSent, emails, resources) {
    /** @type {string} */
    this.id = id;
    /** @type {string} */
    this.name = name;
    /** @type {string} */
    this.organization = organization;
    /** @type {string} */
    this.type = type;
    /** @type {number} */
    this.frequency = frequency;
    /** @type {Date} */
    this.lastSent = lastSent;
    /** @type {string[]} */
    this.emails = emails;
    /** @type {AlertResource[]} */
    this.resources = resources;
  }

  static fromApi = AlertMapper;
}

function AlertMapper({ _id, name, organization, type, frequency, lastSent, emails, resources }) {
  resources && resources.map(AlertResource.fromApi);
  return new Alert(_id, name, organization, type, frequency, lastSent, emails ?? [], resources ?? []);
}

class AlertResource {
  constructor(resourceId, resourceType, lastSent) {
    /** @type {string} */
    this.resourceId = resourceId;
    /** @type {string} */
    this.resourceType = resourceType;
    /** @type {Date} */
    this.lastSent = lastSent;
  }

  static fromApi = AlertResourceMapper;
}

function AlertResourceMapper({ resourceId, resourceType, lastSent }) {
  return new AlertResource(resourceId, resourceType, lastSent);
}
